import { Country } from "../models/Country";

export interface ICountriesState {
    countries: Array<Country>
}

export const initialCountriesState: ICountriesState = {
    countries:[]
}